import { inject, Injectable, Renderer2 } from '@angular/core'

import { iOS } from '@app/utils'

import { ScrollService } from './scroll.service'

@Injectable()
export class ScrollBlockUiService {
  private readonly renderer2 = inject(Renderer2)
  private readonly scrollService = inject(ScrollService)

  init(): void {
    this.scrollService.isBodyScrollDisabled$.subscribe(disabled =>
      disabled ? this.lockScrolling() : this.unlockScrolling(),
    )
  }

  private lockScrolling(): void {
    if (iOS) {
      this.resetMinimalUi()
    }
    this.renderer2.addClass(document.documentElement, 'scroll-locked')
  }

  private unlockScrolling(): void {
    this.renderer2.removeClass(document.documentElement, 'scroll-locked')
  }

  private resetMinimalUi(): void {
    const scrollPosition = window.scrollY
    if (document.documentElement.clientHeight >= window.innerHeight) {
      return
    }
    this.renderer2.setStyle(document.documentElement, 'position', 'fixed')
    this.renderer2.setStyle(document.documentElement, 'top', `-${scrollPosition}px`)
    this.renderer2.setStyle(document.documentElement, 'width', `100%`)

    setTimeout(() => {
      this.renderer2.removeStyle(document.documentElement, 'position')
      this.renderer2.removeStyle(document.documentElement, 'top')
      this.renderer2.removeStyle(document.documentElement, 'width')
      window.scrollTo(0, scrollPosition)
    })
  }
}
